var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Modal/modalView/FirstModal.vue","title":"Несколько модальных окон из под RPopover в первом модальном окне"}},[_c('r-button',{attrs:{"title":"Отрыть модальное окно"},on:{"click":_vm.openModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }